var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.calculatedTag,_vm._g(_vm._b({tag:"component",staticClass:"button",class:{
    ['button_' + _vm.resultTheme]: _vm.resultTheme,
    ['button_' + _vm.size]: _vm.size,
    button_ghost: _vm.ghost,
    button_preload: _vm.loading
  },attrs:{"type":"button","href":_vm.to}},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }